import React from 'react';

export const IconExplore = ({ width, height }) => (
  <svg
    width={width ?? '57'}
    height={height ?? '56'}
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2719_2214)">
      <path
        d="M28.5 9.33337C18.21 9.33337 9.83337 17.71 9.83337 28C9.83337 38.29 18.21 46.6667 28.5 46.6667C38.79 46.6667 47.1667 38.29 47.1667 28C47.1667 17.71 38.79 9.33337 28.5 9.33337ZM33.19 32.69L15.6667 40.8334L23.81 23.31L41.3334 15.1667L33.19 32.69Z"
        fill="#CCFBEF"
      />
      <path
        d="M28.5 4.66663C15.62 4.66663 5.16663 15.12 5.16663 28C5.16663 40.88 15.62 51.3333 28.5 51.3333C41.38 51.3333 51.8333 40.88 51.8333 28C51.8333 15.12 41.38 4.66663 28.5 4.66663ZM28.5 46.6666C18.21 46.6666 9.83329 38.29 9.83329 28C9.83329 17.71 18.21 9.33329 28.5 9.33329C38.79 9.33329 47.1666 17.71 47.1666 28C47.1666 38.29 38.79 46.6666 28.5 46.6666ZM15.6666 40.8333L33.19 32.69L41.3333 15.1666L23.81 23.31L15.6666 40.8333ZM28.5 25.4333C29.9233 25.4333 31.0666 26.5766 31.0666 28C31.0666 29.4233 29.9233 30.5666 28.5 30.5666C27.0766 30.5666 25.9333 29.4233 25.9333 28C25.9333 26.5766 27.0766 25.4333 28.5 25.4333Z"
        fill="#297FFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_2719_2214">
        <rect width="56" height="56" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
